/* eslint-disable */
// @ts-nocheck

import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { FilterX, X } from 'lucide-react'
import { DateRange } from 'react-day-picker'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

// Simplified interface for nuqs-based filters
interface SelectionSummaryProps {
  // Active nuqs filters
  activeStatuses: string[]
  setActiveStatuses: (statuses: string[]) => void
  statusOptions: { value: string; label: string }[]
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
  handleClearFilters: () => void
  activeTypes: string[]
  setActiveTypes: (statuses: string[]) => void
  typeOptions: { value: string; label: string }[]
}

export const SelectionSummary = ({
  activeStatuses,
  setActiveStatuses,
  statusOptions,
  searchQuery,
  setSearchQuery,
  handleClearFilters,
  activeTypes,
  setActiveTypes,
  typeOptions,
}: SelectionSummaryProps) => {
  // Check if any filters are active
  const hasActiveFilters =
    !activeStatuses.includes('all') ||
    !activeTypes.includes('all') ||
    searchQuery !== ''

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {/* Selected Origin Filter Badge */}

      {/* Order Status Filter Badge */}
      {!activeStatuses.includes('all') && (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          variant="secondary"
        >
          <span>
            Estado:{' '}
            {activeStatuses
              .map(
                (s) => statusOptions.find((option) => option.value === s)?.label
              )
              .join(', ')}
          </span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={() => setActiveStatuses(['all'])}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Payment Status Filter Badge */}
      {!activeTypes.includes('all') && (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          variant="secondary"
        >
          <span>
            Tipo:{' '}
            {activeTypes
              .map(
                (s) => typeOptions.find((option) => option.value === s)?.label
              )
              .join(', ')}
          </span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={() => setActiveTypes(['all'])}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Search Query Badge */}
      {searchQuery && (
        <Badge
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
          variant="secondary"
        >
          <span>Búsqueda: {searchQuery}</span>
          <Button
            className="ml-1 h-4 w-4"
            onClick={() => setSearchQuery('')}
            size="icon"
            variant="ghost"
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Clear All Filters Button */}
      {hasActiveFilters && (
        <Button
          className="h-7 gap-1 text-xs"
          onClick={handleClearFilters}
          size="sm"
          variant="ghost"
        >
          <FilterX className="h-3.5 w-3.5" />
          Limpiar filtros
        </Button>
      )}
    </div>
  )
}
